import { Link } from "react-router-dom";
import { Compass, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-32 border-t border-white/5 bg-[#020610]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <Compass className="w-5 h-5 text-[var(--pov-coral)]" />
            <span className="font-display tracking-wider">POINT OV VIEW CONSULTING</span>
          </div>
          <p className="mt-4 text-white/55 max-w-md text-sm leading-relaxed">
            A consulting practice that turns ambition into executed deals — fast, decisively, and
            across industries.
          </p>
        </div>

        <div>
          <p className="overline mb-4">Navigate</p>
          <ul className="space-y-2 text-sm text-white/65">
            <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
            <li><a href="/#who" className="hover:text-white transition-colors">Who We Are</a></li>
            <li><a href="/#fields" className="hover:text-white transition-colors">Expertise</a></li>
            <li><a href="/#portfolio" className="hover:text-white transition-colors">Selected Work</a></li>
            <li><Link to="/book" className="hover:text-white transition-colors">Book</Link></li>
            <li><Link to="/admin/login" className="hover:text-white transition-colors text-white/40 text-xs">Admin</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4">Contact</p>
          <ul className="space-y-3 text-sm text-white/65">
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[var(--pov-cyan)]" /> Contact@askpov.com</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[var(--pov-cyan)]" /> 954-253-7067</li>
          </ul>
        </div>
      </div>
      <div className="hairline">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Point Ov View Consulting. All rights reserved.</p>
          <p>Built for operators who move first and ask permission later.</p>
        </div>
      </div>
    </footer>
  );
}
